import React from 'react'
import { useAdmin } from '@/utils/hooks'
import { CenteredErrorMessage } from '@/components_deprecated/CenteredErrorMessage/CenteredErrorMessage'
import { useTranslate } from '@ur-solutions/react-hooks'

export interface AdminRequiredProps {
  renderMessage?: string
}

export const AdminRequired: React.JSX.CFC<AdminRequiredProps> = ({
  renderMessage,
  children,
}) => {
  const isAdmin = useAdmin()
  const translations = useTranslate({
    adminRequired: 'admin-required.message',
  })

  if (!isAdmin) {
    if (renderMessage) {
      return <CenteredErrorMessage message={translations.adminRequired} />
    }
    return <></>
  }

  return <>{children}</>
}
